/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {ChartOptions, GridLineOptions,} from 'chart.js';
import {PeriodsTypeEnum} from '../../periods-table/models/periods-type.enum';
import {PeriodMouseActionsEnum} from '../../periods-table/models/period-mouse-actions.enum';

const periodsInfoChartConfiguration: {
    infoChartOptions: ChartOptions;
    readonly periodColors: Map<PeriodsTypeEnum, string>;
    readonly periodMouseActionsColors: Map<PeriodMouseActionsEnum, string>;
    readonly ticksConfiguration: any;
    readonly gridLineConfiguration: GridLineOptions;
    readonly gridInvisibleLineDash: number[];
    readonly barSpacingInHours: number;
    readonly barBorderWith: number;
} = {
    infoChartOptions: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            intersect: false,
            axis: 'x'
        },
        elements: {
            point: {
                radius: 0,
                hoverRadius: 0
            }
        },
        layout: {
            padding: {
                top: 48,
                left: 24,
                right: 96
            },
        },
        events: ['mousemove', 'mouseout', 'click']
    },
    periodColors: new Map<PeriodsTypeEnum, string>([
        [PeriodsTypeEnum.PAST, '#000000'],
        [PeriodsTypeEnum.PRESENT, '#8cb0fe'],
        [PeriodsTypeEnum.FUTURE, '#c3beb0'],
    ]),
    periodMouseActionsColors: new Map<PeriodMouseActionsEnum, string>([
        [PeriodMouseActionsEnum.HOVER, '#efefef'],
        [PeriodMouseActionsEnum.CLICK, '#d6dAe3'],
    ]),
    ticksConfiguration: {
        padding: 20,
        tickBarColor: '#b4b4b4',
        count: 3
    },
    gridLineConfiguration: {
        drawTicks: true,
        color: '#b4b4b4',
        lineWidth: 1,
        tickLength: 9,
        tickColor: '#b4b4b4',
        display: true,
        circular: false,
        drawOnChartArea: true,
        tickBorderDash: [2, 8],
        tickBorderDashOffset: 0,
        tickWidth: 1,
        offset: false,
        z: 0,
    } as GridLineOptions,
    gridInvisibleLineDash: [0, 1],
    barSpacingInHours: 22, // range from 0-24 hours,
    barBorderWith: 1
};

export default periodsInfoChartConfiguration;
